<template>
    <div>
        <div
            v-if="deviceData.item.deviceUseBoolean"
        >
            <b-input-group
                size="sm"
                prepend="Set to:"
            >
                <b-button
                    size="sm"
                    @click="validateAndModifyDeviceValFromFieldIfValid(deviceData.item)"
                >
                    Off
                </b-button>
                <b-button
                    size="sm"
                    @click="validateAndModifyDeviceValFromFieldIfValid(deviceData.item)"
                >
                    On
                </b-button>
            </b-input-group>
        </div>
        <div v-else>
            <b-input-group
                size="sm"
                prepend="Set value to:"
            >
                <b-form-input
                    id="deviceValInput"
                    type="number"
                    class="w-25 form-control"
                    placeholder="Enter 0-100"
                    min="0"
                    max="100"
                    :value="deviceData.item.attemptedDeviceVal"
                    @keyup.native="setSanitizedDeviceVal(deviceData.item, $event.target.value)"
                    @blur.native="clearAttemptedDeviceValIfEmpty(deviceData.item, $event.target.value)"
                />
                <b-input-group-append>
                    <b-button
                        disabled
                        size="sm"
                    >
                        %
                    </b-button>
                    <b-button
                        size="sm"
                        @click="validateAndModifyDeviceValFromFieldIfValid(deviceData.item);"
                    >
                        Set D
                    </b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
        <div v-if="deviceData.item.deviceUsePercent">
            <b-button
                v-for="shortcutVal in shortcutButtonVals"
                :key="shortcutVal"
                class="shortcutButton"
                @click="executePercentDeviceShortcutButton(deviceData.item.deviceKey, shortcutVal);"
            >
                {{ shortcutVal }}
            </b-button>
        </div>

        <b-col
            v-if="(!deviceData.item.hasValidDeviceVal)"
            v-show="!deviceData.item.hasValidAttemptedDeviceVal"
            class="text-danger"
        >
            {{ deviceData.item.attemptedDeviceValErrorMessage }}
        </b-col>
    </div>
</template>

<script>
    import { _ } from 'vue-underscore';
    import { getCloudFunctionByName } from '../firebase';

    export default {
        props: {
            deviceData: {
                type:    Object,
                default: () => ({}),
            },
        },

        methods: {
            setSanitizedDeviceVal(device, inputValue) {
                if (_.isString(inputValue) && inputValue.length !== 0) {
                    device.attemptedDeviceVal = parseInt(inputValue, 10);
                }
            },

            clearAttemptedDeviceValIfEmpty(device, inputValue) {
                // should reset to actual idealVal if we blur on an empty input
                if (_.isString(inputValue) && inputValue.length === 0) {
                    device.resetAttemptedDeviceVal();
                }
            },

            executePercentDeviceShortcutButton(deviceKey, shortcutVal) {
                const currDevice = this.getDeviceByKeyFromLocalStore(deviceKey);
                currDevice.attemptedDeviceVal = shortcutVal;
                this.validateAndModifyDeviceValFromFieldIfValid(currDevice);
            },

            validateAndModifyDeviceValFromFieldIfValid(device) {
                device.hasValidAttemptedDeviceVal = device.validateAttemptedDeviceVal();
                if (device.hasValidAttemptedDeviceVal) {
                    this.updateDeviceVal(device);
                }
                device.attemptedDeviceValErrorMessage = device.getDeviceValErrorMessageOrNull();
                this.showErrorMessageForDeviceVal(device, false);
            },

            updateDeviceVal(device) {
                const changeDeviceValFunction = getCloudFunctionByName('deviceValCheckIn');
                const data = {
                    currDeviceID:       device.deviceKey,
                    deviceVal:          device.attemptedDeviceVal,
                    localEditTimestamp: (new Date().getTime()),
                };

                changeDeviceValFunction(data).then((result) => {
                    if (result.data && result.data.error) {
                        // eslint-disable-next-line no-console
                        console.error(result.data);
                    }
                });
            },

            showErrorMessageForDeviceVal(device, blurrHappened) {
                const blurred = blurrHappened;
                const deviceValisGood = device.hasValidAttemptedDeviceVal;

                if (blurred && !deviceValisGood) {
                    return true;
                }
                return false;
            },
        },
    };
</script>
